module.exports = __webpack_public_path__ + "static/img/scene_3.0960200d.png";